import { render, staticRenderFns } from "./MembershipDashboard.vue?vue&type=template&id=54aa19b7&scoped=true"
import script from "./MembershipDashboard.vue?vue&type=script&lang=js"
export * from "./MembershipDashboard.vue?vue&type=script&lang=js"
import style0 from "./MembershipDashboard.vue?vue&type=style&index=0&id=54aa19b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aa19b7",
  null
  
)

export default component.exports